import { createFileRoute, redirect } from '@tanstack/react-router'

/** Moved into Setup › Catalogue; the old address keeps working. */
export const Route = createFileRoute('/attachment-types')({
  beforeLoad: () => {
    throw redirect({ to: '/catalogue/$kind', params: { kind: 'attachment-types' }, replace: true })
  },
})
